/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Command } from '../models/command';
@Injectable({
  providedIn: 'root',
})
class CommandService extends __BaseService {
  static readonly CommandRunCommandPath = '/api/Command/RunCommand';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `CommandService.CommandRunCommandParams` containing the following parameters:
   *
   * - `command`:
   *
   * - `customerId`:
   */
  CommandRunCommandResponse(params: CommandService.CommandRunCommandParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.command;
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Command/RunCommand`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `CommandService.CommandRunCommandParams` containing the following parameters:
   *
   * - `command`:
   *
   * - `customerId`:
   */
  CommandRunCommand(params: CommandService.CommandRunCommandParams): __Observable<Blob> {
    return this.CommandRunCommandResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module CommandService {

  /**
   * Parameters for CommandRunCommand
   */
  export interface CommandRunCommandParams {
    command: Command;
    customerId?: number;
  }
}

export { CommandService }
